import { render, staticRenderFns } from "./edit-country-data.vue?vue&type=template&id=23ce73b4"
import script from "./edit-country-data.vue?vue&type=script&lang=ts"
export * from "./edit-country-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports